import * as angular from "angular";

export class ProspectorService {
    private root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.root = "/v2/prospector/l2";
    }

    count(data: any): Promise<object> {
        return this.$http.post(this.root + "/count", data);
    }

    import(data: any): Promise<object> {
        return this.$http.post(this.root + "/import", data);
    }

    imports(): Promise<object> {
        return this.$http.get(this.root + "/imports");
    }

    startProgress(id: number): Promise<object> {
        return this.$http.get(this.root + "/start_progress/" + id);
    }

    credits(): Promise<object> {
        return this.$http.get(this.root + "/credits");
    }
}

angular.module("vcServices").service("ProspectorService", ProspectorService);
